import request from '../utils/request.js'

//  退出登录
export function LogOutApi(params) {
    return request({
        url: '/payCat/LogOut',
        method: 'post',
        data: params,
        closeLoading: true //closeInterceptors:true  (请求没有Loading，请求没有拦截)
    })
}

//  修改登录密码
export function ChangePasswordApi(params) {
    return request({
        url: '/payCat/UpdateAccountPassword',
        method: 'post',
        data: params,
        closeLoading: true //closeInterceptors:true  (请求没有Loading，请求没有拦截)
    })
}

//  修改支付密码
export function PayPasswordApi(params) {
    return request({
        url: '/payCat/UpdatePayPassword',
        method: 'post',
        data: params,
        closeLoading: true //closeInterceptors:true  (请求没有Loading，请求没有拦截)
    })
}


//  修改支付密码
export function ChartsYybApi(params) {
    return request({
        url: '/admin/charts/reg/yyb?' + params,
        method: 'get',
        closeLoading: true //closeInterceptors:true  (请求没有Loading，请求没有拦截)
    })
}




